import { render, staticRenderFns } from "./emailAlert.vue?vue&type=template&id=288038ca&scoped=true"
import script from "./emailAlert.vue?vue&type=script&lang=js"
export * from "./emailAlert.vue?vue&type=script&lang=js"
import style0 from "./emailAlert.vue?vue&type=style&index=0&id=288038ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288038ca",
  null
  
)

export default component.exports